import React from "react";
import FilterItem from "./FilterItem";
import { Button, Popover, Position, ButtonGroup } from "@blueprintjs/core";
import moment from "moment";
import styles from "./FilterToolbar.module.scss";

function SelectedFilter({ selection, filter, value, onChange }) {
  function getLabel() {
    switch (filter.type) {
      case "menu":
        return selection.label;

      case "dateRange":
        const formattedFrom = moment(new Date(selection[0])).format(
          "MMM. D, YYYY"
        );

        const formattedTo = moment(new Date(selection[1])).format(
          "MMM. D, YYYY"
        );

        return `${formattedFrom} – ${formattedTo}`;

      default:
        throw new Error(`Invalid filter type: ${filter.type}`);
    }
  }

  return (
    <ButtonGroup className={styles.filterButton}>
      <Popover
        position={Position.BOTTOM_RIGHT}
        popoverClassName={styles.individualFilterPopover}
      >
        <Button text={getLabel()} rightIcon="caret-down" className="bold" />

        <FilterItem
          filter={filter}
          filters={value}
          onAddFilter={(selection) =>
            onChange({ ...value, [filter.key]: selection })
          }
        />
      </Popover>
      {!filter.required && (
        <Button
          icon="cross"
          onClick={() => {
            const copiedFilters = { ...value };
            delete copiedFilters[filter.key];
            onChange(copiedFilters);
          }}
        />
      )}
    </ButtonGroup>
  );
}

export default SelectedFilter;
